import type { GalleryImage } from "@/types";

// Get base path from Vite config (e.g., "/projects/alex-chen-photography/" or "/" for dev)
const basePath = import.meta.env.BASE_URL;

export const galleryImages: GalleryImage[] = [
  {
    id: 1,
    title: "Urban Solitude",
    category: "Street",
    year: 2024,
    location: "New York City",
    caption: "A moment of quiet reflection amidst the bustling city streets.",
    image: `${basePath}images/gallery/urban-solitude.jpg`,
    alt: "Person walking alone on urban street with dramatic lighting",
  },
  {
    id: 2,
    title: "Mountain Serenity",
    category: "Landscape",
    year: 2024,
    location: "Rocky Mountains, Colorado",
    caption:
      "Dawn breaks over pristine mountain peaks, painting the sky in ethereal colors.",
    image: `${basePath}images/gallery/mountain-serenity.jpg`,
    alt: "Snow-capped mountain peaks at sunrise with golden light",
  },
  {
    id: 3,
    title: "Grace in Motion",
    category: "Portraits",
    year: 2024,
    location: "Studio, Los Angeles",
    caption: "Capturing the elegance and strength of contemporary dance.",
    image: `${basePath}images/gallery/grace-in-motion.jpg`,
    alt: "Professional portrait of dancer in flowing fabric with dramatic lighting",
  },
  {
    id: 4,
    title: "Architectural Lines",
    category: "Architecture",
    year: 2023,
    location: "Chicago, Illinois",
    caption: "Modern architecture creates bold geometric patterns against the sky.",
    image: `${basePath}images/gallery/architectural-lines.jpg`,
    alt: "Modern skyscraper with geometric patterns against blue sky",
  },
  {
    id: 5,
    title: "Wedding Bliss",
    category: "Events",
    year: 2024,
    location: "Napa Valley, California",
    caption:
      "A perfect moment of joy and celebration captured in golden hour light.",
    image: `${basePath}images/gallery/wedding-bliss.jpg`,
    alt: "Wedding couple embracing in vineyard during golden hour",
  },
  {
    id: 6,
    title: "Fashion Forward",
    category: "Editorial",
    year: 2024,
    location: "Miami, Florida",
    caption:
      "Bold fashion meets urban landscape in this striking editorial piece.",
    image: `${basePath}images/gallery/fashion-forward.jpg`,
    alt: "Fashion model in avant-garde clothing against urban background",
  },
  {
    id: 7,
    title: "City Lights",
    category: "Street",
    year: 2023,
    location: "Tokyo, Japan",
    caption: "Neon reflections create a cyberpunk dreamscape in the rain.",
    image: `${basePath}images/gallery/city-lights.jpg`,
    alt: "Rainy Tokyo street at night with neon light reflections",
  },
  {
    id: 8,
    title: "Desert Dreams",
    category: "Landscape",
    year: 2023,
    location: "Antelope Canyon, Arizona",
    caption: "Light beams dance through the sculpted sandstone walls.",
    image: `${basePath}images/gallery/desert-dreams.jpg`,
    alt: "Light beams streaming through Antelope Canyon sandstone walls",
  },
  {
    id: 9,
    title: "Executive Portrait",
    category: "Portraits",
    year: 2024,
    location: "Corporate Office, San Francisco",
    caption: "Professional headshot capturing confidence and approachability.",
    image: `${basePath}images/gallery/executive-portrait.jpg`,
    alt: "Professional executive headshot in modern office setting",
  },
  {
    id: 10,
    title: "Concert Energy",
    category: "Events",
    year: 2024,
    location: "Madison Square Garden, NYC",
    caption: "Raw energy and emotion captured in the heat of live performance.",
    image: `${basePath}images/gallery/concert-energy.jpg`,
    alt: "Concert performer on stage with dramatic lighting and crowd",
  },
  {
    id: 11,
    title: "Minimalist Beauty",
    category: "Editorial",
    year: 2024,
    location: "Studio, New York",
    caption: "Clean lines and soft light create timeless elegance.",
    image: `${basePath}images/gallery/minimalist-beauty.jpg`,
    alt: "Minimalist beauty portrait with soft natural lighting",
  },
  {
    id: 12,
    title: "Gothic Revival",
    category: "Architecture",
    year: 2023,
    location: "Notre Dame Cathedral, Paris",
    caption: "Ancient stonework tells stories of centuries past.",
    image: `${basePath}images/gallery/gothic-revival.jpg`,
    alt: "Gothic cathedral with intricate stone architecture and flying buttresses",
  },
];
